import { AdminDashboard } from "./Admin";
import { FulfillerDashboard } from "./Fulfiller";

export const UserDashboard = {
  Admin: AdminDashboard,
  Fulfiller: FulfillerDashboard
}
